import type { HubJumps, TradeHub } from "../types/chain";

export const HUB_LETTER: Record<TradeHub, string> = {
  Jita: "J",
  Amarr: "A",
  Dodixie: "D",
  Rens: "R",
  Hek: "H",
};

export const TRADE_HUB_NAMES: ReadonlySet<string> = new Set([
  "Jita",
  "Amarr",
  "Dodixie",
  "Rens",
  "Hek",
]);

export const HUB_PRIORITY: readonly TradeHub[] = [
  "Jita",
  "Amarr",
  "Hek",
  "Dodixie",
  "Rens",
];

export function closestHub(
  hubJumps: HubJumps | undefined,
): { hub: TradeHub; jumps: number } | null {
  if (!hubJumps) return null;
  let best: { hub: TradeHub; jumps: number } | null = null;
  for (const hub of HUB_PRIORITY) {
    const jumps = hubJumps[hub];
    if (jumps == null) continue;
    if (best === null || jumps < best.jumps) {
      best = { hub, jumps };
    }
  }
  return best;
}

const JITA_NEARBY_THRESHOLD = 10;

export interface TradeHubDisplay {
  closest: { hub: TradeHub; jumps: number };
  jita: { jumps: number } | null;
}

export function tradeHubDisplay(
  hubJumps: HubJumps | undefined,
): TradeHubDisplay | null {
  const closest = closestHub(hubJumps);
  if (!closest) return null;
  if (closest.hub === "Jita") return { closest, jita: null };
  const jitaJumps = hubJumps?.Jita;
  const jita =
    jitaJumps != null && jitaJumps < JITA_NEARBY_THRESHOLD
      ? { jumps: jitaJumps }
      : null;
  return { closest, jita };
}
